export const name = 'storesWixCodeSdk' as const
export const namespace = 'stores' as const
